/** @format */

import { Location } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiServiceService } from "src/app/Services/api-service.service";
import { ProfilingUserComponent } from "../profiling-user/profiling-user.component";
import { BsModalService } from "ngx-bootstrap/modal";
import {
	AbstractControl,
	FormBuilder,
	FormGroup,
	ValidatorFn,
	Validators,
} from "@angular/forms";
import * as alertify from "alertifyjs";
import { SuccessDialogComponent } from "src/app/Shared/shared/success-dialog/success-dialog.component";
import { ErrorDialogComponent } from "src/app/Shared/shared/error-dialog/error-dialog.component";
import { ConfirmDialogComponent } from "src/app/Shared/shared/confirm-dialog/confirm-dialog.component";
import { UploadFileService } from "src/app/Shared/upload-file.service";
import { finalize } from "rxjs";
import { ImageCroppedEvent } from "ngx-image-cropper";
import { CropProfilePictureComponent } from "../crop-profile-picture/crop-profile-picture.component";
import { EditUserPersonaiInformationComponent } from "./edit-user-personai-information/edit-user-personai-information.component";
import { AuthService } from "src/app/Services/auth.service";
import { EditUserOtherPersonalInformationComponent } from "./edit-user-other-personal-information/edit-user-other-personal-information.component";
import { NgbNav } from "@ng-bootstrap/ng-bootstrap";

@Component({
	selector: "app-admin-user-profile",
	templateUrl: "./admin-user-profile.component.html",
	styleUrls: ["./admin-user-profile.component.css"],
})
export class AdminUserProfileComponent implements OnInit, AfterViewInit {
	@ViewChild('nav')
	private nav!: NgbNav;

	userAsin: number | null = null;
	userDetail: any;
	editNonCompanyForm: FormGroup;
	editCompanyForm: FormGroup;
	lgaList: any;
	occupationList: any;
	isLoading: boolean;
	userDetails: any;
	companyDetails: any;
	profiles: any;
	isSaving: boolean;
	assessments: any;
	showProfilePhoto: boolean;
	uploadedImage: File;
	uploading: boolean;
	uploaded: any;
	isuploading: boolean;
	success: boolean;
	image: string;
	uploadingMessage: string;
	isUploaded: boolean;
	showCropModal: boolean;

	jtbTin: string | null = null;
	showJtbTin: boolean = false;
	loadingJtbTin: boolean = false;

	userType1: any;
	userType2: any;

	selectedUserType: string = "";
	latestTransaction: any;

	isEmpty: boolean = true;

	transactionCurrentPage: number = 1;
	transactionIsEmpty: boolean = true;
	transactionNum: number = 1;
	transactionPage: number = 0;
	transactionCount: number = 0;
	transactionPageSize: number = 5;
	transactions: any;
	transactionIsLoading: boolean;
	transactionIsSearching: boolean;
	showEditPersonalInformationForm: boolean;

	copy_message: string = "";
	marketList: any[] = [];

	companyEnumerationForm: FormGroup;

	companyEnumerationDetails: any;
	whtList: any[] = [];

	isFirstTab: boolean = true;
	isLastTab: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private location: Location,
		private apiService: ApiServiceService,
		private bsModalService: BsModalService,
		public fb: FormBuilder,
		private router: Router,
		private uploadService: UploadFileService,
		private authenticationService: AuthService,
		private http: HttpClient,
	) {
		this.userAsin = this.route.snapshot.queryParams["page"];
		this.editNonCompanyForm = this.fb.group({
			userId: [""],
			phoneNumber: [
				"",
				[Validators.required, this.phoneNumberValidator.bind(this)],
			],
			email: ["", [Validators.required, this.emailValidator()]],
			address: ["", Validators.required],
			lgaId: [""],
			lgaName: [""],
			firstName: ["", Validators.required],
			lastName: ["", Validators.required],
			gender: [""],
			occupationId: [""],
			dob: [""],
			maritalStatus: [""],
			nin: ["", Validators.required],
			tin: ["", Validators.required],
		});

		this.editCompanyForm = this.fb.group({
			userId: [""],
			phoneNumber: [
				"",
				[Validators.required, this.phoneNumberValidator.bind(this)],
			],
			email: ["", [Validators.required, this.emailValidator()]],
			address: ["", Validators.required],
			lgaId: [""],
			lgaName: [""],
			corporateName: ["", Validators.required],
			classification: [""],
			natureOfBusiness: [""],
			rcNumber: [""],
			tin: ["", Validators.required],
		});

		this.companyEnumerationForm = this.fb.group({
			numberOfEmployees: [null],
			numberOfBranches: [null],

			estimatedRevenue: [null],
			averageStaffSalary: [null],
			ownershipType: [""],

			businessContactFirstName: [""],
			businessContactLastName: [""],
			businessContactEmail: [""],
			businessContactPhoneNumber: [""],

			closestTaxOffice: [""],

			jtbTin: [""],

			vehicleCount: [null],
			corporatePropertyCount: [null],
			corporateAssetCount: [null],
		});
	}

	ngOnInit(): void {
		this.validateAsin();
		this.getAllLga();
		this.getAllOccupation();
		this.initOtherDetails();
		this.getState();
		this.fetchOtherInformation();
		this.showEditPersonalInformationForm = false;
	}

	ngAfterViewInit(): void {
		const items = this.nav?.items.toArray() ?? [];
		const currentIndex = items?.findIndex(item => item.id === this.nav.activeId);

		if (!items.length) return;

		this.isFirstTab = currentIndex <= 0;
		this.isLastTab = currentIndex == (items.length - 1);
	}

	// Use the same type as your NgbNavItem IDs.
	// Your existing items without explicit IDs receive generated IDs.
	activeId: string | number | undefined;

	navigateTab(direction: -1 | 1): void {
		const items = this.nav?.items.toArray() ?? [];

		const currentIndex = items.findIndex(
			item => item.id === this.nav.activeId
		);

		const nextIndex = currentIndex + direction;
		const nextItem = items[nextIndex];

		if (!nextItem) return;

		this.nav.select(nextItem.id);
		this.scrollToTab(nextItem.id);

		this.isFirstTab = nextIndex <= 0;
		this.isLastTab = nextIndex == (items.length - 1);
	}

	onActiveTabChange(id: string | number): void {
		requestAnimationFrame(() => this.scrollToTab(id));

		const items = this.nav?.items.toArray() ?? [];

		const currentIndex = items.findIndex(
			item => item.id === this.nav.activeId
		);

		this.isFirstTab = currentIndex <= 0;
		this.isLastTab = currentIndex == (items.length - 1);
	}

	private scrollToTab(id: string | number): void {
		const link = this.nav?.links.find(
			item => item?.navItem.id === id
		);

		link?.elRef.nativeElement.scrollIntoView({
			behavior: 'smooth',
			block: 'nearest',
			inline: 'nearest',
		});
	}

	hasAccess(permissions: string[]) {
		return this.authenticationService.hasAnyPermission(permissions);
	}
	copyASIN(text: string) {
		// userDetail?.tinNumber ?? 0
		navigator.clipboard
			.writeText(text)
			.then(() => {
				console.log("Text copied to clipboard");
			})
			.catch((err) => {
				console.error("Could not copy text: ", err);
			});
		this.copy_message = "copied!";
		setTimeout(() => {
			this.copy_message = "";
		}, 5000);
	}

	remove(id: any) {
		const url = `/auth/profiling/delete/${id}`;
		this.apiService.LoginGet(url).subscribe(
			(response) => {
				this.isSaving = false;

				this.isLoading = false;

				this.getAllProfilesByUser();

				alertify.set("notifier", "position", "top-center");
				alertify.success("Deleted successfully");
			},
			(error) => {
				this.confirmAfterError("Action was not successful");
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
				this.isLoading = false;
				this.isSaving = false;
			},
		);
	}

	viewAssessment(assessmentId: any) {
		this.router.navigate([`/nt-demand-notice/${assessmentId}`]);
	}

	transformPaymentStatus(status: string): string {
		return status.replace("_", " ").toUpperCase();
	}

	confirmEdit() {
		let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
			initialState: {
				body: "Proceed to save changes",
			},
			class: "modal-sm modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
			this.saveNonCompanyEdits();
			dfModalRef.hide();
		});
	}

	confirmCompanyEdit() {
		let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
			initialState: {
				body: "Proceed to save changes",
			},
			class: "modal-sm modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
			this.saveCompanyEdits();
			dfModalRef.hide();
		});
	}

	saveCompanyEdits() {
		this.isLoading = true;

		let pojo = this.editCompanyForm.value;

		pojo["userId"] = this.userDetail?.userId;

		const url = "/auth/edit-user-details";

		this.apiService.loginPost_(url, pojo).subscribe(
			(response) => {
				this.isLoading = false;

				if (response.status == "OK") {
					this.confirmAfterSuccess(response.message);
					alertify.set("notifier", "position", "top-center");
					alertify.success("Account has been successfully updated");
				} else {
					this.confirmAfterError("Action was not successful");
					alertify.set("notifier", "position", "top-center");
					alertify.error("Error performing this operation");
				}
			},
			(error) => {
				console.log(error);
				this.confirmAfterError("Action was not successful");
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
				this.isLoading = false;
			},
		);
	}

	saveNonCompanyEdits() {
		this.isLoading = true;

		let pojo = this.editNonCompanyForm.value;

		pojo["userId"] = this.userDetail?.userId;

		const url = "/auth/edit-user-details";

		this.apiService.loginPost_(url, pojo).subscribe(
			(response) => {
				this.isLoading = false;

				if (response.status == "OK") {
					this.confirmAfterSuccess(response.message);
					alertify.set("notifier", "position", "top-center");
					alertify.success("Account has been successfully updated");
				} else {
					this.confirmAfterError("Action was not successful");
					alertify.set("notifier", "position", "top-center");
					alertify.error("Error performing this operation");
				}
			},
			(error) => {
				console.log(error);
				this.confirmAfterError("Action was not successful");
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
				this.isLoading = false;
			},
		);
	}

	confirmAfterSuccess(message: any) {
		let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
			initialState: {
				body: message,
			},
			class: "modal-sm modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
			dfModalRef.hide();
		});
	}

	confirmAfterError(message: any) {
		let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
			initialState: {
				body: message,
			},
			class: "modal-sm modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
			dfModalRef.hide();
		});
	}

	getUserDetails() {
		let request = {
			userId: this.userDetail?.userId,
			taxGroup: this.userDetail?.taxgroup,
		};

		const url = "/auth/user/details";

		if (
			this.userDetail?.taxgroup != "COMPANY" &&
			this.userDetail?.taxgroup != "INFORMAL"
		) {
			this.apiService.loginPost_(url, request).subscribe(
				(response) => {
					this.userDetails = response;

					this.editNonCompanyForm.patchValue({
						firstName: this.userDetails?.firstName || "",
						phoneNumber: this.userDetails?.phoneNumber || "",
						email: this.userDetails?.email || "",
						address: this.userDetails?.address || "",
						lastName: this.userDetails?.lastName || "",
						nin: this.userDetails?.nin || "",
						tin: this.userDetails?.tin || "",
						dob: this.userDetails?.dob || "",
					});

					this.isLoading = false;
				},
				(error) => {
					alertify.set("notifier", "position", "top-center");
					alertify.error("Error performing this operation");
					this.isLoading = false;
				},
			);
		} else {
			this.apiService.loginPost_(url, request).subscribe(
				(response) => {
					this.companyDetails = response;

					this.editCompanyForm.patchValue({
						corporateName: this.companyDetails?.displayName || "",
						phoneNumber: this.companyDetails?.phoneNumber || "",
						email: this.companyDetails?.email || "",
						rcNumber: this.companyDetails?.rcNumber || "",
						tin: this.companyDetails?.tin || "",
						address: this.companyDetails?.address || "",
					});

					this.getCompanyEnumerationInfo();

					this.isLoading = false;
				},
				(error) => {
					alertify.set("notifier", "position", "top-center");
					alertify.error("Error performing this operation");
					this.isLoading = false;
				},
			);
		}

		this.getAllProfilesByUser();
	}

	getAllOccupation() {
		this.apiService.LoginGet("/auth/occupation/all").subscribe(
			(reponse) => {
				this.occupationList = reponse;
			},
			(error) => {
				console.log(error);
			},
		);
	}

	emailValidator(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null => {
			// Regular expression for a strict email format validation
			const emailPattern =
				/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

			if (control.value && !emailPattern.test(control.value)) {
				return { invalidEmail: true };
			}

			return null;
		};
	}

	phoneNumberValidator(control: any) {
		const phoneNumber = control.value;
		if (!phoneNumber) {
			return { required: true }; // Required validation error
		}

		// Remove spaces and hyphens and check if the result contains only digits
		const cleanedPhoneNumber = phoneNumber
			.replace(/\s/g, "")
			.replace(/-/g, "");
		const isDigitsOnly = /^\d+$/.test(cleanedPhoneNumber);

		// Check if the input is exactly 11 digits, 13 digits starting with '234', or 14 characters starting with '+234'
		if (
			(cleanedPhoneNumber.length === 11 && isDigitsOnly) ||
			(cleanedPhoneNumber.length === 13 &&
				cleanedPhoneNumber.startsWith("234")) ||
			(cleanedPhoneNumber.length === 14 &&
				cleanedPhoneNumber.startsWith("+234"))
		) {
			return null; // Valid phone number
		} else {
			return { invalidPhoneNumber: true }; // Invalid phone number format
		}
	}

	validateAsin() {
		this.showProfilePhoto = false;

		if (this.userAsin == null) {
			this.location.back();
		}

		this.apiService
			.loginPost_(`/auth/utility/asin?asin=${this.userAsin}`, null)
			.subscribe({
				next: (response) => {
					this.userDetail = response;
					console.log("this.userDetail", this.userDetail);

					if (this.userDetail?.photo) {
						this.showProfilePhoto = true;
					}

					if (this.userDetail?.taxgroup == "COMPANY") {
						this.userType1 = "COMPANY";
						this.userType2 = "INFORMAL";

						this.selectedUserType = "COMPANY";
					}

					if (this.userDetail?.taxgroup == "INFORMAL") {
						this.userType2 = "COMPANY";
						this.userType1 = "INFORMAL";

						this.selectedUserType = "INFORMAL";
					}

					this.getUserDetails();
				},
				error: (error) => {
					console.log(error);
					// this.location.back();
				},
			});
	}

	getCompanyEnumerationInfo() {
		const url = `/auth/enumeration/details/company/${this.userDetail?.userId}`;
		this.apiService.LoginGet(url).subscribe(
			(response) => {
				this.companyEnumerationDetails = response.data;

				this.companyEnumerationForm.patchValue({
					numberOfEmployees:
						this.companyEnumerationDetails?.numberOfEmployees ||
						"n/a",
					numberOfBranches:
						this.companyEnumerationDetails?.numberOfBranches ||
						"n/a",

					estimatedRevenue:
						this.companyEnumerationDetails?.estimatedRevenue ||
						"n/a",
					averageStaffSalary:
						this.companyEnumerationDetails?.averageStaffSalary ||
						"n/a",
					ownershipType:
						this.companyEnumerationDetails?.ownershipType || "n/a",

					businessContactFirstName:
						this.companyEnumerationDetails
							?.businessContactFirstName || "n/a",
					businessContactLastName:
						this.companyEnumerationDetails
							?.businessContactLastName || "n/a",
					businessContactEmail:
						this.companyEnumerationDetails?.businessContactEmail ||
						"n/a",
					businessContactPhoneNumber:
						this.companyEnumerationDetails
							?.businessContactPhoneNumber || "n/a",

					jtbTin: this.companyEnumerationDetails?.jtbTin || "n/a",

					closestTaxOffice:
						this.companyEnumerationDetails?.closestTaxOffice ||
						"n/a",

					vehicleCount:
						this.companyEnumerationDetails?.vehicleCount || "n/a",
					corporatePropertyCount:
						this.companyEnumerationDetails
							?.corporatePropertyCount || "n/a",
					corporateAssetCount:
						this.companyEnumerationDetails?.corporateAssetCount ||
						"n/a",
				});
			},
			(error) => {
				console.log(error);
			},
		);
	}

	newProfiling() {
		let dfModalRef = this.bsModalService.show(ProfilingUserComponent, {
			initialState: {
				user: this.userDetail,
			},
			class: "modal-lg modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
			dfModalRef.hide();
		});
	}

	getAllProfilesByUser() {
		const url = `/auth/profiling/get_profiles/${this.userDetail?.userId}`;
		this.apiService.LoginGet(url).subscribe(
			(response) => {
				this.profiles = response.data;
			},
			(error) => {
				console.log(error);
			},
		);

		this.getAllAssessments();

		this.getAllWhts();
	}

	getAllAssessments() {
		const url = `/assessments/all/assessment/userId/${this.userDetail?.userId}`;

		this.apiService.get(url).subscribe(
			(reponse) => {
				this.assessments = reponse.data;
			},
			(error) => {
				console.log(error);
			},
		);
	}

	getAllWhts() {
		const url = `/assessments/all/wht/userId/${this.userDetail?.userId}`;

		this.apiService.get(url).subscribe(
			(reponse) => {
				this.whtList = reponse.data;
			},
			(error) => {
				console.log(error);
			},
		);
	}

	uploadProfile(event: any) {
		this.image = "";
		this.success = false;
		this.isuploading = true;
		this.uploadingMessage = "uploading...";
		let profileDocs = event.target.files;
		let currentFile = profileDocs[0];

		this.uploadService
			.Cloudupload(currentFile)
			.pipe(finalize(() => {}))
			.subscribe(
				(response: any) => {
					if (response.body && response.body.secure_url != "") {
						this.image = response.body?.secure_url;
						this.success = true;
						this.isUploaded = true;
						this.isuploading = false;
						this.confirmAfterSuccess("Photo uploaded successfully");
						alertify.set("notifier", "position", "top-center");
						alertify.success("Photo uploaded successfully");
						this.isuploading = false;
					}
				},
				(err) => {
					this.confirmAfterError("Action was not successful");
					alertify.set("notifier", "position", "top-center");
					alertify.error("Error performing this operation");
					currentFile = null;
					this.isuploading = false;
				},
			);
	}

	selectDocument(event: any) {
		let element: HTMLElement = document.getElementById(
			"photo",
		) as HTMLElement;
		element.click();
	}

	openCropModal() {
		// this.showCropModal = true;

		let bsModalRef = this.bsModalService.show(CropProfilePictureComponent, {
			class: "modal-md modal-dialog-centered",
			ignoreBackdropClick: true,
			initialState: {
				userId: this.userDetail?.userId,
			},
		});
		bsModalRef?.content?.onConfirmClicked.subscribe((v) => {
			bsModalRef.hide();
		});
	}

	cropComplete(event: ImageCroppedEvent) {
		if (event) {
			this.uploadProfile(event.base64); // Pass the cropped image data to the uploadProfile method
		}
		this.showCropModal = false;
	}

	changeUserType() {
		let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
			initialState: {
				body: "Proceed to save tax group",
			},
			class: "modal-sm modal-dialog-centered",
		});
		dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
			this.saveTypeChange();
			dfModalRef.hide();
		});
	}

	saveTypeChange() {
		const url = `/auth/update/tax_group/${this.userDetail?.userId}/${this.selectedUserType}`;

		this.apiService.loginPost_(url, null).subscribe({
			next: (response) => {
				if (response?.data) {
					this.confirmAfterSuccess("Tax group updated successfully");
					alertify.set("notifier", "position", "top-center");
					alertify.success("Tax group updated successfully");
				}
			},
			error: (error) => {
				console.log(error);
				this.confirmAfterError("Tax group updated was not successful");
				alertify.set("notifier", "position", "top-center");
				alertify.error("Tax group updated was not successful");
			},
		});
	}

	goBack() {
		this.location.back();
	}

	getLatestTransaction() {
		let asin = this.userDetail?.tinNumber;

		const url = `/assessments/search/user/most-recent/paid-payments?asin=${asin}`;

		this.apiService.post(url, {}).subscribe(
			(response) => {
				this.latestTransaction = response?.data;
			},
			(error) => {
				console.log(error);
				this.confirmAfterError("Action was not successful");
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
			},
		);
	}

	getAllTransactions() {
		let asin = this.userDetail?.tinNumber;

		// let asin = "44444";

		const url = "/assessments/search/user/paid-payments";

		var formData: any = new FormData();

		this.transactionIsEmpty = false;

		this.transactionNum = this.transactionPage * 5;

		formData.append("offset", this.transactionNum);

		formData.append("asinExternal", asin);

		this.apiService.post(url, formData).subscribe(
			(response) => {
				this.transactions = response.results;

				if (this.transactions.length > 0) {
					this.transactionIsLoading = false;

					this.transactionCount = Math.ceil(response.total);

					this.transactionIsSearching = false;
				} else {
					this.transactionIsLoading = false;

					this.transactionIsSearching = false;
					this.transactionIsEmpty = true;
				}
			},
			(error) => {
				console.log(error);
				this.confirmAfterError("Action was not successful");
				alertify.set("notifier", "position", "top-center");
				alertify.error("Error performing this operation");
				this.transactionIsLoading = false;
			},
		);
	}

	callTranscationsDb(event: any) {
		this.transactionCurrentPage = event;

		this.transactionPage = event - 1;

		this.getAllTransactions();
	}

	editPersonalInformation() {
		let bsModalRef = this.bsModalService.show(
			EditUserPersonaiInformationComponent,
			{
				class: "modal-xl modal-dialog-centered",
				ignoreBackdropClick: true,
				initialState: {
					userDetail: this.userDetail,
				},
			},
		);
		bsModalRef?.content?.onConfirmClicked.subscribe((v) => {
			bsModalRef.hide();
		});
	}

	editOtherPersonalInformation() {
		let bsModalRef = this.bsModalService.show(
			EditUserOtherPersonalInformationComponent,
			{
				class: "modal-xl modal-dialog-centered",
				ignoreBackdropClick: true,
				initialState: {
					userDetail: this.userDetail,
				},
			},
		);
		bsModalRef?.content?.onConfirmClicked.subscribe((payload) => {
			bsModalRef.hide();
			if (payload) {
				this.fetchOtherInformation();
			}
		});
	}

	getAllMarket() {
		this.apiService
			.get_("/assessments/get/shop/owner?phoneNumber=" + this.userAsin)
			.subscribe(
				(reponse) => {
					this.marketList = reponse.data;
				},
				(error) => {
					console.log(error);
				},
			);
	}

	checkMarket() {
		this.getAllMarket();
	}

	getAllLga() {
		console.log("get all lgas ");
		this.apiService.LoginGet("/auth/lga/all/states").subscribe(
			(reponse) => {
				this.lgaList = reponse;
			},
			(error) => {
				console.log(error);
			},
		);
	}

	form: FormGroup;
	initOtherDetails() {
		this.form = this.fb.group({
			incomeCategory: [""],
			employerName: [""],
			incomeRange: [""],
			sourceOfIncome: [""],
			totalAnnualIncome: [""],
			closestTaxOffice: [""],
			numberOfVehicles: [null],
			natureOfBusiness: [""],
			educationLevel: [""],

			hasVehicle: [null],
			hasProperty: [null],
			propertyType: [null],

			// CONTACT
			state: [""],
			stateOfOrigin: [""],
			lgaOfOrigin: [""],
			lga: [""],
			landMark: [""],

			// RENT
			accommodationType: [""],
			buildingType: [""],
			rentPeriodCovered: [""],
			periodType: [""],
			rentAmount: [""],
			numberOfRooms: [""],
			rentPeriodCoveredStart: [""],
			rentPeriodCoveredEnd: [""],

			// LANDLORD
			landlordFullName: [""],
			landlordPhoneNumber: [""],
			landlordAsin: [""],
			landlordEmail: [""],
			landlordAddress: [""],

			doesLandlordLiveSameApartment: [""],

			hasBusiness: [null],
			ownCompany: [null],
		});
	}

	otherInformation: any = null;
	loadingOtherInfo: boolean = false;
	fetchOtherInformation() {
		this.apiService
			.LoginGet(`/auth/utility/profile/update?asin=${this.userAsin}`)
			.subscribe((res: any) => {
				const data = res.data;
				this.otherInformation = data;
				this.patchForm(data);
			});
	}

	patchForm(data: any) {
		this.form.patchValue({
			incomeCategory: data.incomeCategory,
			employerName: data.employerName,
			incomeRange: data.incomeRange,
			sourceOfIncome: data.sourceOfIncome,
			natureOfBusiness: data.natureOfBusiness,
			accommodationType: data.accommodationType,
			buildingType: data.buildingType,
			rentAmount: data.rentAmount,
			periodType: data.periodType,
			totalAnnualIncome: data.totalAnnualIncome,
			numberOfRooms: data?.numberOfRooms,
			hasVehicle: data.hasVehicle ? "YES" : "NO",
			hasProperty: data.hasProperty ? "YES" : "NO",
			propertyType: data.propertyType,
			hasBusiness: data?.hasBusiness ? "YES" : "NO",
			ownCompany: data?.ownCompany ? "YES" : "NO",
			educationLevel: data?.educationLevel,
			landMark: data?.landMark,
			numberOfVehicles: data?.numberOfVehicles,

			landlordFullName: data?.landLordName,
			landlordPhoneNumber: data?.landlordPhoneNumber,
			landlordAsin: data?.landlordAsin,
			landlordEmail: data?.landlordEmail,
			landlordAddress: data?.landlordAddress,
			doesLandlordLiveSameApartment: data?.sharedApartmentWithLandLord
				? "YES"
				: "NO",
		});

		if (data.state) {
			let state = this.states?.find((st) => st.id == data.state);
			this.form.patchValue({ state: state?.name });
			if (data.lga) {
				let lga = this?.lgaList?.find((lg) => lg.id == data.lga);
				this.form.patchValue({ lga: lga?.name });
			}
		}

		if (data.stateOfOrigin) {
			let state = this.states?.find((st) => st.id == data.stateOfOrigin);
			this.form.patchValue({ stateOfOrigin: state?.name });

			if (data.stateOfOriginLga) {
				let lga = this.lgaList?.find(
					(lg) => lg.id == data.stateOfOriginLga,
				);
				this.form.patchValue({ lgaOfOrigin: lga?.name });
				// this.disableControlName("lgaOfOrigin");
			}
		}

		if (data.rentPeriodCovered) {
			const { startDate, endDate } = this.parseFormattedRentPeriod(
				data.rentPeriodCovered,
			);
			console.log(`startDate: ${startDate} and endDate: ${endDate}`);

			this.form.patchValue({
				rentPeriodCovered: data.rentPeriodCovered,
				rentPeriodCoveredStart: startDate,
				rentPeriodCoveredEnd: endDate,
			});
		}

		// After patching form values
		// Object.keys(this.form.value).forEach((controlName) => {
		//   this.disableControlName(controlName);
		// });
	}

	// disableControlName(controlName) {
	//   const control = this.form.get(controlName);
	//   if (control?.value) {
	//     control.disable();
	//   }
	// }

	// new logic added from public user
	chosenMonthHandler(normalizedMonth: Date, datepicker: any) {
		const ctrlValue = new Date(normalizedMonth);
		ctrlValue.setDate(1); // force day=1
		if (!this.form.value.rentPeriodCoveredStart) {
			this.form.patchValue({ rentPeriodCoveredStart: ctrlValue });
		} else {
			this.form.patchValue({ rentPeriodCoveredEnd: ctrlValue });
		}
		datepicker.close();
	}

	parseFormattedRentPeriod(formattedPeriod: string): {
		startDate: Date | null;
		endDate: Date | null;
	} {
		if (!formattedPeriod || !formattedPeriod.includes("–")) {
			return { startDate: null, endDate: null };
		}

		try {
			// Split the formatted string
			const [startStr, endStr] = formattedPeriod
				.split("–")
				.map((s) => s.trim());

			// Parse back to Date objects (adjust format based on your mediumDate output)
			const startDate = new Date(startStr);
			const endDate = new Date(endStr);

			// Validate the dates
			if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
				return { startDate: null, endDate: null };
			}

			return { startDate, endDate };
		} catch (error) {
			console.error("Error parsing rent period:", error);
			return { startDate: null, endDate: null };
		}
	}

	fetchJtbTin() {
		const tin = this.userDetail?.tinNumber;
		if (!tin) return;

		this.loadingJtbTin = true;
		this.showJtbTin = false;
		this.jtbTin = null;

		this.apiService.get(`/auth/enumeration/jrb/get-tin?asin=${tin}`)
			.subscribe({
				next: (res) => {
					this.jtbTin = res?.data?.data?.tin ?? res?.data?.tin ?? null;
					this.showJtbTin = true;
					this.loadingJtbTin = false;
				},
				error: () => {
					this.loadingJtbTin = false;
					alertify.set("notifier", "position", "top-center");
					alertify.error("Could not retrieve JTB TIN");
				},
			});
	}

	hideJtbTin() {
		this.showJtbTin = false;
		this.jtbTin = null;
	}

	states: any;
	getState() {
		this.apiService.LoginGet("/auth/state/all", {}).subscribe((res) => {
			this.states = res.map((state: any) => ({
				...state,
				name: this.toTitleCase(state.name),
			}));
		});
	}

	public toTitleCase(str: string): string {
		return str
			.toLowerCase()
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
			.join(" ");
	}
}
